module.exports = __webpack_public_path__ + "img/icon_blue-big_pin-location.bddef26c.svg";